import WujiTips from "../wujiTips";
export function AsyncCatch() {
  return function (_target, _methodName, desc) {
    const method = desc.value;
    desc.value = async function (...args) {
      try {
        const res = await method.apply(this, args);
        return res;
      } catch (error) {
        const wujiTips = new WujiTips();
        wujiTips.error({
          content: error.message || '请求失败'
        });
      }
    };
    return desc;
  };
}
//# sourceMappingURL=AsyncCatch.js.map
